import React, { Component } from 'react';
import WidgetList from 'react-widgets/lib/List';
import { withTranslation } from 'react-i18next';

class MultiSelectListWithPaging extends Component {

	render() {
		const { hasNextPage, onNextPage, t, ...rest } = this.props;

		return <div>
			<WidgetList {...rest} />
			{hasNextPage && <div style={{ textAlign: 'center', marginTop: '10px', cursor: 'pointer', textDecoration: 'underline' }} onClick={onNextPage}>{t('List_ShowMore')}</div>}
		</div>;
	}
}
// withRef is required: react-widgets' Multiselect attaches a ref to its listComponent and calls
// forceUpdate() on it when the popup opens. Without it the ref lands on the translation HOC's own
// function component, listRef stays undefined, and opening the dropdown throws.
export default withTranslation(undefined, { withRef: true })(MultiSelectListWithPaging);